import React, { useContext, useState, useEffect } from 'react'
import { handleRedirectInternal } from '@/product/common/components'
import CommonContext from '@/product/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import Loaders from '@/product/components/molecules/Loaders'
import AgencyForm from './AgencyForm'
import UsersIndex from '@/product/customViews/AgencyManagement/usersIndex'
import AgencyContext from '@/product/context/agency/agencyContext'
import Layout from '@/product/components/templates/Layout'

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <>{children}</>
                </div>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

const AgencyManage = (props) => {
    const commonContext = useContext(CommonContext)
    const authContext = useContext(AuthContext)
    const agencyContext = useContext(AgencyContext)
    const data = props.data
    const isFullScreen = props.data ? true : false
    const toggleFullScreenPopup = props.function
    const { user } = authContext
    const { USStates, allCountries, allStates } = commonContext
    const [isLoading, setIsLoading] = useState(false)
    const {
        all_agency,
        responseStatus: responseStatusAgency,
        clearResponse: clearResponseUser,
    } = agencyContext
    const [allAgency, setAllAgency] = React.useState([])
    const [value, setValue] = useState(0)
    const [singleAgency, setSingleAgency] = useState([])
    const [showUsers, setShowUsers] = useState(false)
    const [agencyId, setAgencyId] = useState(0)

    const handleChange = (newValue) => {
        setValue(newValue)
    }

    useEffect(() => {
        // if (props?.data?.id && props?.allData?.length) {
        //     let _allData = [...props?.allData]
        //     let singleAgency = _allData.filter(
        //         (each) => each.id === props?.data?.id
        //     )[0]
        //     setSingleAgency(singleAgency)
        // } else
        if (props?.match?.params?.id && parseInt(props?.match?.params?.id)) {
            console.log(allAgency, props?.match?.params?.id, 'agencyy')
            let _allData = allAgency
            let singleAgency = _allData.filter(
                (each) => each.id == props?.match?.params?.id
            )[0]
            setAgencyId(parseInt(props?.match?.params?.id))
            setSingleAgency(singleAgency)
        }
    }, [props?.match?.params?.id])

    useEffect(() => {
        if (all_agency?.records?.length) {
            let _allAgency = [...all_agency?.records]
            let allAgency = []
            _allAgency.map((each) => {
                let eachAgency = { ...each }
                eachAgency['phone'] = each.agencies_phone?.length
                    ? each.agencies_phone.map((eachPhone) => {
                          return eachPhone?.is_default
                              ? eachPhone?.phone
                              : each.agencies_phone[0]?.phone
                      })[0]
                    : '-'
                eachAgency['address'] = each.agencies_address?.length
                    ? each.agencies_address.map((eachAddress) => {
                          return eachAddress?.is_default
                              ? eachAddress?.address_line_1
                              : each.agencies_address[0]?.address_line_1
                      })[0]
                    : '-'
                allAgency.push(eachAgency)
            })
            console.log(allAgency, 'allooooooo')
            setAllAgency(allAgency)
        } else {
            setAllAgency([])
        }
        setIsLoading(false)
    }, [all_agency])

    useEffect(() => {
        if (user?.emp_type == 'agency' && user?.user_level == 'user') {
            setValue(1)
        } else setValue(0)
    }, [data?.popup])
    useEffect(() => {
        if (props?.match?.params?.id) {
            if (user?.emp_type == 'agency' && user?.user_level == 'user') {
                setValue(1)
            } else setValue(0)
        }
    }, [props?.match?.params?.id])

    const agencyBasicDetails = [
        {
            label: 'Agency Name',
            type: 'text',
            placeholder: 'Enter your agency name',
            class: 'col-sm-6 col-12',
            name: 'agency_name',
        },
        {
            label: 'Agency Short Name',
            placeholder: 'Enter agency short name',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'agency_short_name',
        },
        {
            label: 'Parent Agency',
            placeholder: 'Select a parent agency',
            class: 'col-sm-6 col-12',
            type: 'select',
            options: [
                { value: '1', show: 'First Agency' },
                { value: '2', show: 'Second Agency' },
                { value: '3', show: 'Third Agency' },
            ],
            name: 'parent_agency_id',
        },
        {
            title: 'Agency Type',
            type: 'radio',
            name: 'agency_type',
            class: 'col-12 col-sm-6',
            options: [
                { id: 1, description: 'State Agency' },
                { id: 2, description: 'Local Unit of Government(LUG)' },
            ],
            int: 1,
        },
    ]
    useEffect(() => {
        if (responseStatusAgency?.status === 'success') {
            setShowUsers(true)
            if (props?.match?.params?.status == 'new') {
                console.log(responseStatusAgency, 'response')
                if (
                    responseStatusAgency.data &&
                    responseStatusAgency.data?.data?.agency_id &&
                    !(
                        responseStatusAgency?.from === 'addressupdate' ||
                        responseStatusAgency?.from === 'phoneupdate' ||
                        responseStatusAgency?.from === 'defaultupdate' ||
                        responseStatusAgency?.from === 'paymentupdate' ||
                        responseStatusAgency?.from === 'deleteupdate'
                    )
                ) {
                    console.log(responseStatusAgency.data, 'response adta')
                    setAgencyId(responseStatusAgency.data.data.agency_id)
                }
            }
        }
    }, [responseStatusAgency])

    useEffect(() => {
        if (props?.match?.params?.status === 'new') {
            setShowUsers(false)
            setAgencyId(0)
        } else setShowUsers(true)
    }, [props?.match?.params?.status])

    return isFullScreen && props?.data ? (
        <FullScreenPopup
            modaltitle={
                data.status === 'new' ? 'ADD NEW AGENCY' : 'EDIT AGENCY'
            }
            open={
                data.status === 'edit' || data.status === 'new'
                    ? data.popup
                    : false
            }
            handleClose={() => {
                setIsLoading(false), toggleFullScreenPopup(false, '', 0)
            }}
        >
            <div className="addAgencyModal">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <div className="agencyDetailTabs">
                            <AppBar position="static">
                                <Tabs
                                    value={value}
                                    // onChange={handleChange}
                                    aria-label="simple tabs example"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                >
                                    {user?.emp_type == 'agency' &&
                                    user?.user_level == 'user' ? null : (
                                        <Tab
                                            label="Agency Profile"
                                            value={0}
                                            onClick={() => handleChange(0)}
                                        />
                                    )}

                                    {showUsers ? (
                                        <Tab
                                            label="Agency Users"
                                            value={1}
                                            onClick={() => handleChange(1)}
                                        />
                                    ) : null}
                                </Tabs>
                            </AppBar>
                            {user?.emp_type == 'agency' &&
                            user?.user_level == 'user' ? null : (
                                <TabPanel value={value} index={0}>
                                    <AgencyForm
                                        data={props.data}
                                        agencyBasicDetails={agencyBasicDetails}
                                        toggleFullScreenPopup={props.function}
                                        agencyId={agencyId}
                                    />
                                </TabPanel>
                            )}
                            {showUsers ? (
                                <TabPanel value={value} index={1}>
                                    <UsersIndex
                                        data={props.data}
                                        custom={true}
                                        agencyId={agencyId}
                                        agencyData={singleAgency}
                                        toggleFullScreenPopup={props.function}
                                    />
                                </TabPanel>
                            ) : null}
                        </div>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    ) : (
        <>
            <Layout>
                <div className="addAgencyModal page mt-3">
                    <div className="">
                        {isLoading ? (
                            <div className="fspLoader">
                                <Loaders isLoading={isLoading} />
                            </div>
                        ) : (
                            <div className="agencyDetailTabs">
                                <AppBar position="static">
                                    <Tabs
                                        value={value}
                                        // onChange={handleChange}
                                        aria-label="simple tabs example"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                    >
                                        {user?.emp_type == 'agency' &&
                                        user?.user_level == 'user' ? null : (
                                            <Tab
                                                label="Agency Profile"
                                                value={0}
                                                onClick={() => handleChange(0)}
                                            />
                                        )}

                                        {showUsers ? (
                                            <Tab
                                                label="Agency Users"
                                                value={1}
                                                onClick={() => handleChange(1)}
                                            />
                                        ) : null}
                                    </Tabs>
                                </AppBar>
                                {user?.emp_type == 'agency' &&
                                user?.user_level == 'user' ? null : (
                                    <TabPanel value={value} index={0}>
                                        <AgencyForm
                                            agencyBasicDetails={
                                                agencyBasicDetails
                                            }
                                            agencyId={agencyId}
                                            agencyStatus={
                                                props?.match?.params?.status
                                            }
                                        />
                                    </TabPanel>
                                )}
                                {showUsers ? (
                                    <TabPanel value={value} index={1}>
                                        <UsersIndex
                                            custom={true}
                                            agencyId={agencyId}
                                            agencyData={singleAgency}
                                            agencyStatus={
                                                props?.match?.params?.status
                                            }
                                        />
                                    </TabPanel>
                                ) : null}
                            </div>
                        )}
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AgencyManage
